import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@coin/shared/auth/data-access';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'auth-gms-angular-client',
  template: '',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class AuthGmsClientCallbackComponent implements OnInit {
  private readonly auth = inject(AuthService);

  ngOnInit() {
    this.auth.handleLoginCallback();
  }
}
